import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getClubMeetsData from './GetClubMeetsData';
import getClubUsasSanctionedMeetsData from './GetClubUsasSanctionedMeetsData';
import getClubApprovedMeetsData from './GetClubApprovedMeetsData';

import postClubMeetSanctionRequestData from '@usas/ui-web/state/meet/PostMeetData';
import putClubMeetSanctionRequestData from '@usas/ui-web/state/meet/PutMeetData';  
import postApprovedMeetData from '@usas/ui-web/state/meet/PostApprovedMeetData';
import putApprovedMeetData from '@usas/ui-web/state/meet/PutApprovedMeetData';
import deleteMeetData from '@usas/ui-web/state/meet/DeleteMeetData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const ClubMeetsData = {
  INITIAL_STATE,
  getClubMeetsData,
  getClubUsasSanctionedMeetsData,
  postClubMeetSanctionRequestData,
  putClubMeetSanctionRequestData,
  postApprovedMeetData,
  putApprovedMeetData,  
  deleteMeetData,
  getClubApprovedMeetsData
};

export default ClubMeetsData;